import { render, staticRenderFns } from "./DeveloperListApartmentCommercialBuildings.vue?vue&type=template&id=27ffe5d6&"
import script from "./DeveloperListApartmentCommercialBuildings.vue?vue&type=script&lang=js&"
export * from "./DeveloperListApartmentCommercialBuildings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports